import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { API } from "@/api";

export default function WaitlistForm({ source = "site" }) {
  const [email, setEmail] = useState("");
  const [joined, setJoined] = useState(false);
  const [sending, setSending] = useState(false);

  const join = async (e) => {
    e.preventDefault();
    if (sending || joined) return;
    setSending(true);
    try {
      const { data } = await axios.post(`${API}/waitlist`, { email, source });
      setJoined(true);
      toast.success(data.status === "already_registered" ? "You're already on the list." : "You're on the list. CHWA-01 launch news is coming.");
    } catch (err) {
      toast.error("Couldn't join the waitlist. Try again.");
    } finally {
      setSending(false);
    }
  };

  if (joined) {
    return (
      <div data-testid={`waitlist-success-${source}`} className="mx-auto max-w-md border border-zinc-700 px-8 py-5">
        <p className="font-display text-lg font-semibold uppercase tracking-[0.15em] text-zinc-50">You're on the list.</p>
        <p className="mt-1 text-xs uppercase tracking-[0.25em] text-zinc-500">CHWA-01 — First allocation news coming</p>
      </div>
    );
  }

  return (
    <form data-testid={`waitlist-form-${source}`} onSubmit={join} className="mx-auto flex max-w-md border border-zinc-700 transition-colors duration-300 focus-within:border-zinc-300">
      <input
        data-testid={`waitlist-input-email-${source}`}
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Email for launch access"
        className="w-full bg-transparent px-5 py-4 text-sm text-zinc-100 placeholder-zinc-600 outline-none"
      />
      <button
        data-testid={`waitlist-submit-button-${source}`}
        type="submit"
        disabled={sending}
        className="group flex shrink-0 items-center gap-2 bg-zinc-100 px-6 text-xs font-semibold uppercase tracking-[0.25em] text-zinc-950 transition-colors duration-300 hover:bg-white disabled:opacity-50"
      >
        {sending ? "..." : "Join"}
        <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1" />
      </button>
    </form>
  );
}
